import styled from 'styled-components';
export const CartHeader = styled.div`
  display: flex;
  align-items: center;
  margin: 25px 0 12px 0;
`;

export const Icon = styled.div`
  width: 24px;
  height: 22px;
  margin-right: 20px;
`;

export const Title = styled.h6`
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.lightPurple};
  margin-right: 14px;
`;

export const Amount = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body14};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.lightPurple};
`;

export const AsideHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  & + .swiper {
    padding-bottom: 20px;
    .swiper-pagination {
      bottom: 2px;
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.colors.lightPurple};
        background-color: transparent;
        opacity: 1;
        &.swiper-pagination-bullet-active {
          background-color: ${({ theme }) => theme.colors.lightPurple};
        }
      }
    }
  }
`;

export const AsideTitle = styled.h6`
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
`;

export const AddBtn = styled.button`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.brandColor};
  height: 36px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.brandColor};
  padding: 0 12px;
`;

export const GrayTitle = styled.h6`
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.lightPurple};
  margin: 0 0 14px 0;
`;
